import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { StyledNavLinkBase, StyledNavLinkLi } from 'components/common/nav/nav_link_styles';

import Link from 'components/common/link';

const StyledLink = styled(Link)`
  ${StyledNavLinkBase};
`;

/**
 * @visibleName Nav Link
 */
const NavLink = ({ children, className = '', dataAid = 'pageLink', isActive, onClick, to }) => {
  return (
    <StyledNavLinkLi data-aid={dataAid} className={className} isActive={isActive}>
      <StyledLink key={`reportHeaderTab-reportUrl`} onClick={onClick} href={to}>
        {children}
      </StyledLink>
    </StyledNavLinkLi>
  );
};

NavLink.propTypes = {
  /** Child components of the NavLink, usually a link component */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  /** CSS class names to allow custom styling */
  className: PropTypes.string,
  /** String to specify a data-aid for testing */
  dataAid: PropTypes.string,
  /** Boolean for if a link should have isActive styling applied */
  isActive: PropTypes.bool,
  /** The label for the PageLink anchor */
  label: PropTypes.string,
  /** The onClick function for the Link */
  onClick: PropTypes.func,
  /** The url destination of the PageLink */
  to: PropTypes.string,
};

export { NavLink, StyledLink, StyledNavLinkBase, StyledNavLinkLi };



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/common/nav/nav_link.jsx